import { useEffect, useState } from "react";

import { getViewportSize, subscribeToViewportResize } from "@/utils/browserMetrics";

const useSize = () => {
  const [windowSize, setWindowSize] = useState(() => getViewportSize());

  useEffect(() => {
    const windowSizeHandler = () => {
      setWindowSize(getViewportSize());
    };

    windowSizeHandler();
    return subscribeToViewportResize(windowSizeHandler);
  }, []);

  return windowSize;
};

export default useSize;
